/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable @next/next/no-img-element */
import { Modal } from "@material-ui/core";
import React, { useState } from "react";
import clsx from "clsx";
import Image from "next/image";
import DOWNLOAD_APNA_APP_LINK from "constants/downloadApnaAppLink";
import { useWindowResize } from "utils/hooks";
import CrossWithBGIcon from "components/RevampFeedDetails/assets/CrossWithBGIcon";
import CrossIcon from "components/RevampFeedDetails/assets/CrossIcon";

const WalkInNudgeModal = ({
	open,
	isCandidateEligible,
	appliedJobDetails,
	handleClose,
	openDownloadAppNudge,
}) => {
	const [isMobileView] = useWindowResize();

	const [showWalkInEligibleBs, setShowWalkInEligibleBs] = useState(false);

	const handleDownloadAppClick = () => {
		if (isMobileView) window.open(DOWNLOAD_APNA_APP_LINK);
		if (showWalkInEligibleBs) setShowWalkInEligibleBs(false);

		openDownloadAppNudge();
	};
	return (
		<Modal open={open}>
			<div className="relative flex h-full w-full items-center justify-center md:static">
				<div className="fixed bottom-0 right-0 z-20 h-auto w-full  md:relative md:max-h-[678px] md:max-w-[688px] md:rounded-[12px]">
					<div
						className="flex cursor-pointer items-center justify-end px-[16px] py-[12px] md:hidden"
						onClick={handleClose}
					>
						<CrossWithBGIcon />
					</div>
					<div
						className="hidden cursor-pointer items-center justify-end rounded-t-[8px] bg-white px-[16px] pt-[12px] md:flex"
						onClick={handleClose}
					>
						<CrossIcon fill="#190A28" size="24" />
					</div>
					{!isCandidateEligible ? (
						<div
							className={clsx(" bg-white pt-[16px]", {
								"rounded-0 rounded-b-[8px]": !isMobileView,
								"rounded-t-[8px]": isMobileView,
							})}
						>
							<div className="mx-[16px] space-y-[8px] md:mx-[104px] md:text-center">
								<p className="m-0 text-[20px] font-bold leading-[28px] text-[#190A28]">
									Call HR to check interview eligibility
								</p>
								<p className="m-0 text-[14px] leading-[20px] text-[#8C8594]">
									The HR has specific requirements which may not match
									with your profile, please call HR to check if
									you&apos;re the right fit for the job.
								</p>
							</div>
							<div className="mx-[16px] mb-0 mt-[16px] max-w-[440px] rounded-lg border border-solid border-[#CB2F4B] p-[12px] md:mx-auto md:my-[24px]">
								<p className="m-0 text-sm leading-[20px] text-[#8C8594]">
									{
										appliedJobDetails?.job_applied_mismatch_nudge
											?.heading
									}
								</p>
								<div className="mt-[12px] space-y-[12px]">
									{appliedJobDetails?.job_applied_mismatch_nudge?.data?.requirements?.map(
										(reqObj) => (
											<div
												className={clsx(
													"mt-[12px] flex items-start gap-[8px]"
												)}
											>
												<div>
													<Image
														src={reqObj?.icon_link}
														alt="icon"
														width={16}
														height={16}
														layout="fixed"
													/>
												</div>
												<div>
													<div className="text-sm leading-[20px] text-[#190A28]">
														{reqObj?.title}
													</div>
													{reqObj?.sub_text && (
														<div className="text-sm leading-[20px] text-[#8C8594]">
															{reqObj?.sub_text}
														</div>
													)}
												</div>
											</div>
										)
									)}
								</div>
							</div>
							<div className="pb-[24px] pt-[16px] md:py-[24px] md:shadow-inner">
								<div
									className="mx-[16px] cursor-pointer rounded border border-solid bg-[#1F8268] px-[16px] py-[12px] text-center font-semibold text-white md:mx-[124px]"
									onClick={handleDownloadAppClick}
								>
									Download app to call HR
								</div>
							</div>
						</div>
					) : (
						<div
							className={clsx(" bg-white pt-[16px]", {
								"rounded-0 rounded-b-[8px]": !isMobileView,
								"rounded-t-[8px]": isMobileView,
							})}
						>
							<div className="mx-[16px] md:mx-[104px]">
								<p className="m-0 text-start text-[20px] font-bold leading-[28px] text-[#190A28] md:text-center">
									{appliedJobDetails?.job_applied_match_nudge?.text}
								</p>
							</div>
							<div className="m-[16px] max-w-[440px] space-y-[16px] md:mx-[124px] md:my-[24px]">
								{appliedJobDetails?.job_applied_match_nudge?.meta_data?.description_list?.map(
									(nudge) => (
										<div
											className="flex items-center gap-[16px]"
											key={nudge?.title}
										>
											<Image
												src={nudge?.icon_url}
												height={48}
												width={48}
											/>
											<p className="m-0 flex-1 text-[14px] leading-[20px] text-[#190A28] md:text-[16px] md:leading-[24px]">
												{nudge?.title}
											</p>
										</div>
									)
								)}
							</div>
							<div className="pb-[24px] md:py-[24px] md:shadow-inner">
								<div
									className="mx-[16px] cursor-pointer rounded border border-solid bg-[#1F8268] px-[16px] py-[12px] text-center font-semibold text-white md:mx-[124px]"
									onClick={() => handleClose()}
								>
									Okay, got it
								</div>
							</div>
						</div>
					)}
				</div>
				{/* Overlay */}
				{/* {(showDowloadAppModal || showWalkInEligibleBs) && (
					<div className="absolute left-0 top-0 z-10 h-full w-full overflow-hidden bg-black opacity-70" />
				)} */}
			</div>
		</Modal>
	);
};

export default WalkInNudgeModal;
